import { TODO } from '@b2b/types/core/utils';
import angular, { IScope } from 'angular';

export const FormsControllerModule = angular
  .module('acme.view.application.forms.controllers', [])
  .controller('FormsController', [
    '$scope',
    function FormsController($scope: IScope & { forms: TODO }) {
      $scope.forms = {
        model: 'Your spankin new application.forms view!',

        init: function () {},

        success: {
          init: function (response) {},
        },

        error: {
          init: function (response) {},
        },
      };

      $scope.forms.init();
    },
  ]).name;
